module.exports = __webpack_public_path__ + "img/boutique.a42f6e23.png";